import { Component, OnInit, OnDestroy, Output, Input, ApplicationRef, EventEmitter } from "@angular/core";
import { Subscription, Observable, of, combineLatest, defer } from "rxjs";
import { Validators, FormControl, FormGroup } from "@angular/forms";
import { map, mergeMap, shareReplay, startWith, switchMap, tap, withLatestFrom } from "rxjs/operators";
import { ProvinciaDTO } from "../../models/provincia-dto";
import { MessageService } from "../../services/message.service";
import { TipologicheService } from "../../services/tipologiche/tipologiche.service";
import { ComponentOutputStatus } from "../../normalizzazione/component-output-status";
import { TribunaleDTO } from "../../models/tribunale-dto";
import { AutoritaOrdinanteDTO } from "../../models/autorita-ordinante-dto";
type errorServiceFailed = {
	error: string
}
type provinciaAndTribunali = {
	tribunali: Array<TribunaleDTO>,
	siglaProvincia: string
}
type OUTPUT_COMPONENT = string | ComponentOutputStatus<TribunaleDTO> | ComponentOutputStatus<errorServiceFailed>
@Component({
	selector: 'lib-dati-tribunale',
	templateUrl: './dati-tribunale.component.html',
	styleUrls: ['./dati-tribunale.component.css']
})
export class DatiTribunaleComponent implements OnInit, OnDestroy {
	@Input()
	province: Observable<Array<ProvinciaDTO>>;
	@Input()
	autoritaOrdinante: AutoritaOrdinanteDTO;
	cf$: Observable<string>;
	form = new FormGroup({});
	tribunali$: Observable<TribunaleDTO[]>;
	$valuechangeTrib: Subscription;
	@Output()
	done: EventEmitter<any> = new EventEmitter<any>();
	$changeTribunale: Subscription;


	constructor(
		private msg: MessageService,
		private tipologiche: TipologicheService,
		private appRef: ApplicationRef

	) { }
	ngOnDestroy(): void {
		if (this.$valuechangeTrib) {
			this.$valuechangeTrib.unsubscribe();
		}
		if (this.$changeTribunale) {
			this.$changeTribunale.unsubscribe();
		}
	}

	ngOnInit() {
		const localitaProvinciaAC = new FormControl(
			{ value: this?.autoritaOrdinante?.codiceProvincia, disabled: false },
			[Validators.required]
		);
		this.form.addControl("localitaProvinciaAC", localitaProvinciaAC);

		const tribunaleAC = new FormControl(
			{ value: '', disabled: false }, c => {
				return String(c.value || '').length > 0
					? {}
					: { 'required': 'Il campo è obbligatorio.' }
			});
		this.form.addControl("tribunaleAC", tribunaleAC);

		/* const tribunaleCF = new FormControl(
			{ value: "", disabled: true }
		);
		this.form.addControl("tribunaleCF", tribunaleCF); */

		//reccupero_tribunali
		this.tribunali$ = localitaProvinciaAC.valueChanges
			.pipe(
				startWith(this.autoritaOrdinante?.codiceProvincia),
				switchMap((value) => this.tipologiche.getTribunali$(value)
					.pipe(withLatestFrom(of(value)))),
				// tap(_ => console.log("outMergeMap", _)),
				//SE SI PROVIENE DALLE BOZZE => SI RESETTA IL TRIBUNALE
				tap(([tribunali, value]) => {
					if (value == this.autoritaOrdinante?.codiceProvincia) {
						tribunaleAC.setValue(this.autoritaOrdinante.idTribunale)
					} else {
						tribunaleAC.setValue(null);
					}
				}),
				map(([tribunali, value]) => tribunali),
				shareReplay()
				// catchError(error=> )
			);

		//Build_output_steam
		const changeTribinali$ = defer(() => this.tribunali$);
		const streamOutput$ = combineLatest([
			changeTribinali$,
			tribunaleAC.valueChanges])
			.pipe(map(([listaTribunali, tribunaleSelected]) => listaTribunali.find(
				tribunale => tribunale.id == tribunaleSelected)),
				map(tribunale => ComponentOutputStatus.of(this.form.valid, tribunale)))

		/* this.cf$ = tribunaleAC.valueChanges
			.pipe(
				tap(_ => console.log("cf$", _)),
				switchMap(value => this.tribunali$.pipe(
					map(trib => trib.find(
						tribunale => tribunale.codiceistat == value)?.codiceFiscale
					))
				)
			) */

		//OUTPUT_COMPONENT
		this.$valuechangeTrib = streamOutput$.pipe(
		).subscribe(out => this.done.emit(out))
	}


	resetTribunale() { }

}